import React from 'react';
import { Modal } from "react-bootstrap";
import ErrorMessage from './ErrorMessage';
import { ucFirst } from "../../../../../../util/Helpers";
import { GiftCardIcon } from '../../../../../../util/Icons';


const CreateGiftCard = ({ show, action: { action, error, data }, onHide }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <GiftCardIcon />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{ error }} />
                <div className='px-md-5'>
                    <div className="row">
                        <div className="col-lg py-4">
                            <h6>Vendor</h6>
                            <span className="text-muted">{data?.vendor}</span>
                        </div>
                        <div className="col-lg py-4">
                            <h6>Asset ID</h6>
                            <span className="text-muted">{data?.instrumentId}</span>
                        </div>
                    </div>
                    <div className="py-4">
                        <h6>Description</h6>
                        <span className="text-muted">{data?.description}</span>
                    </div>
                    <div className="row">
                        <div className="col-lg py-4">
                            <h6>Amount</h6>
                            <span className="text-muted">{data?.amount}</span>
                        </div>
                        <div className="col-lg py-4">
                            <h6>Number of Cards</h6>
                            <span className="text-muted">{data?.quantity}</span>
                        </div>
                        <div className="col-lg py-4">
                            <h6>Colour</h6>
                            <span className="text-muted">{data?.colour}</span>
                        </div>
                    </div>
                    <div className="row">
                        {
                            Object.keys(data?.model || {}).map((key) => (
                                <div key={key} className="col-3 py-4">
                                    <h6>{ucFirst(key)}</h6>
                                    <span className="text-muted">{data?.model[key]}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreateGiftCard;